import { NavLink, useParams, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// Redux
import { useAppDispatch, useAppSelector } from 'app/hooks/useStore';
// Actions
import { AIChatActions } from 'app/store/AIChat/AIChat.slice';
// Selectors
import { selectHasAnyDocumentOcred } from 'app/store/DMSDocuments/DMSDocuments.selectors';
// Mui
import { Box, Theme } from '@mui/material';
// Components
import { Button } from 'app/components/Mui';
import Icon from 'app/components/Icon';
// Hooks
import useCasePermissionResolved from 'app/hooks/useCasePermissionResolver';

export default function NewChatButton(){
  const { t } = useTranslation();

  // Dispatch
  const dispatch = useAppDispatch();
  // State
  const hasAnyDocumentOcred = useAppSelector(selectHasAnyDocumentOcred);

  const location = useLocation();
  const { caseId } = useParams<{ caseId: string }>();

  const { caseAIChatEnabled, isCaseProcessingReadyOrNotStarted } = useCasePermissionResolved();

  const handleClick = () => {
    dispatch(AIChatActions.setInitialField('conversation'));
  }

  const enableButton = caseAIChatEnabled && isCaseProcessingReadyOrNotStarted && hasAnyDocumentOcred;

  const to = `/admin/cases/${caseId}/ai-chat`;
  const isActive = location.pathname === to;

  if ( !enableButton ) return null;
  return (
    <Box sx={{ flexShrink: 0, width: '100%' }}>
      <Button
        name="Create conversation"
        sx={(theme:Theme) => ({
          borderRadius: 0,
          textTransform: 'none',
          gap: 4,
          justifyContent: 'flex-start',
          backgroundColor: isActive ? theme.palette.primary.light : 'transparent',
          borderLeft: `4px solid ${isActive ? theme.palette.primary.main : 'transparent'}`,
          height: 48,
          pl: 3,
          '&:hover': {
            backgroundColor: theme.palette.primary.light
          },
          '& .MuiIcon': {
            color: isActive ? theme.palette.primary.main : 'rgba(0, 0, 0, 0.54)'
          }
        })}
        component={NavLink}
        to={`/admin/cases/${caseId}/ai-chat`}
        onClick={handleClick}
        fullWidth
      >
        <span className="MuiIcon">
          <Icon icon="new_chat" />
        </span>
        <span style={{ color: 'rgba(0, 0, 0, 0.87)' }}>{t('pages.aiChat.newChatButton')}</span>
      </Button>
    </Box>
  )
};
